import BaseCtrl from 'edge/platform/base/BaseCtrl';
import EntityUtil from 'gw-portals-util-js/EntityUtil';
import _ from 'underscore';

var fn = function fn($scope, StateUtils, submissionViewModel, CoveragesUtil, CoverageService, InsuranceSuiteMetadata, ViewModelService, CppFlowConstants, QuestionSetService) {
    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();

    var glClassCodeSegments = InsuranceSuiteMetadata.get('pc').types.getTypelist('SegmentPortal_AMA');
    $scope.glClassCodeSegment_AMA = '';

    var businesTypeCreate = function businesTypeCreate(data) {
        return ViewModelService.create(data || {
            tempID: EntityUtil.nextId()
        }, 'pc', 'ama.edge.capabilities.policyjob.lob.commercialpackage.dto.CppBusinessTypeDTO');
    };
    var newGLDTO = function newGLDTO() {
        return ViewModelService.create({
            coverables: {
                exposure: {
                    classCodes: []
                }
            }
        }, 'pc', 'ama.edge.capabilities.policyjob.lob.generalliability.dto.GlLobDataDTO');
    };

    var newGLExposure = function newGLExposure() {
        return ViewModelService.create({}, 'pc', 'ama.edge.capabilities.policyjob.lob.generalliability.coverables.dto.GlExposureDTO');
    };

    var setGridLayout = function setGridLayout() {
        if ($scope.availableGLClassCodes.filter(function (el) {
            return el.segment_AMA == $scope.selectedSegmentCode;
        }).length > 5) {
            return 'ama-2-col-grid ';
        } else {
            return '';
        }
    };

    var setSegmentFlags = function setSegmentFlags() {
        var isValid = true;
        if ($scope.showSegmentValidation != undefined) {
            if ($scope.selectedSegmentCode == undefined) {
                $scope.showSegmentValidation = true;
                isValid = false;
            } else {
                $scope.showSegmentValidation = false;
                if ($scope.exposureVM.classCodes.value.length == 0) {
                    $scope.showExposureValidation = true;
                    isValid = false;
                } else {
                    $scope.showExposureValidation = false;
                }
            }
        }
        return isValid;
    };

    ctrl.init = function () {
        $scope.questionSets = submissionVM.lobData.commercialPackage.preQualQuestionSets.value;
        $scope.questionSets = QuestionSetService.getQuestionSetViewModel($scope.questionSets);

        // Check defaults and fix it.
        // [{
        //     "code": "CPPQuestionSet_AMA",
        //     "answers": {
        //         "CPP_BusinessService_AMA": null,
        //         "CPP_BusinessSource_AMA": null,
        //         "CPP_EmpCriminalOffence_AMA": null,
        //         "CPP_BusClaimsMadeIn5Years_AMA": null,
        //         "CPP_CancelBusInsurance_AMA": null,
        //         "CPP_DirectSettle_AMA": null
        //     }
        // }]
        // QnB flow creates submission after Wizard entry, calling dependent coverage map here ensures a quoteID
        //CoveragesUtil.getDependentCoveragesForLOB(CoverageService, submissionVM.quoteID.value);
        $scope.glClassCodeSegments = glClassCodeSegments.codes;
        $scope.availableGLClassCodes = CppFlowConstants.CPPGLCodes_AMA;
        $scope.generalLiabilityVM = newGLDTO();
        $scope.exposureVM = newGLExposure();
        $scope.generalLiabilityVM.coverables.exposure.value = $scope.exposureVM.value;
        $scope.selectedSegment_AMA = {};
        submissionVM.generalLiability = $scope.generalLiabilityVM;
        $scope.submissionVM = submissionVM;
        if ($scope.submissionVM.value.lobData.commercialPackage.generalLiability.coverables.exposure.classCodes.length > 0) {
            $scope.selectedSegmentCode = $scope.submissionVM.value.lobData.commercialPackage.generalLiability.coverables.exposure.classCodes[0].segment_AMA;
            $scope.selectedSegment_AMA.segment_AMA = $scope.selectedSegmentCode;

            glClassCodeSegments.codes.forEach(function (object, index) {
                if (object.code === $scope.selectedSegmentCode) {
                    $scope.DDSelected = object;
                }
            });

            $scope.exposureVM.classCodes = $scope.submissionVM.value.lobData.commercialPackage.generalLiability.coverables.exposure.classCodes;
        }
        $scope.amaTwoColumnGrid = setGridLayout();

        // ADDRESSES Line1 is not populated; fixed the implementation.
        $scope.firstLocationAddress = $scope.submissionVM.value.lobData.commercialPackage.commercialProperty.coverables.locations[0].address;
        if (!$scope.firstLocationAddress.addressLine1) {
            $scope.firstLocationAddress.addressLine1 = $scope.firstLocationAddress.streetNumber_CAA + ', ' + $scope.firstLocationAddress.streetName_CAA + ' ' + $scope.firstLocationAddress.streetType_CAA + ' ' + $scope.firstLocationAddress.direction_CAA;
        }

        var acctHldrAddnlAddr = _.first($scope.submissionVM.baseData.accountHolder.additionalAddresses.value);
        if (acctHldrAddnlAddr) {
            if (!acctHldrAddnlAddr.addressLine1) {
                acctHldrAddnlAddr.addressLine1 = $scope.acctHldrAddnlAddr.streetNumber_CAA + ', ' + $scope.acctHldrAddnlAddr.streetName_CAA + ' ' + $scope.acctHldrAddnlAddr.streetType_CAA + ' ' + $scope.acctHldrAddnlAddr.direction_CAA;
            }
        }

        $scope.nextButtonConfig = {
            class: 'button'
        };
        $scope.prevButtonConfig = {
            class: 'button--de-emphasized'
        };

        $scope.$watch('DDSelected', function () {
            ctrl.updateSelection($scope.DDSelected);
        });

        if (!submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.totalRevenue.amount.value) {
            submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.totalRevenue.amount = _.extend({}, submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.totalRevenue.amount, {
                aspects: {
                    valid: false
                }
            });
            //  submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.totalRevenue.amount.aspects.valid = false;
        }
    };

    ctrl.updateSelection = function (segment) {

        if (segment == undefined) {

            delete $scope.selectedSegmentCode;
            delete $scope.selectedSegment_AMA.segment_AMA;
        } else {

            if (segment.code !== $scope.selectedSegmentCode) {
                $scope.selectedSegment_AMA = _.extend({}, $scope.selectedSegment_AMA, {
                    segment_AMA: segment.code
                });
                //$scope.selectedSegment_AMA.segment_AMA = segment.code;
                $scope.selectedSegmentCode = segment.code;
                $scope.exposureVM.classCodes.value = [];
            }
        }

        $scope.amaTwoColumnGrid = setGridLayout();
        setSegmentFlags();
    };

    ctrl.defineWatchers = function () {};

    ctrl.updateBusinessTypeSelection = function (cppItem) {
        $scope.exposureVM.classCodes.value = $scope.exposureVM.classCodes.value || [];
        var businessTypeIdx = _.findIndex($scope.exposureVM.classCodes.value, function (item) {
            return item.publicID === cppItem.publicID;
        });
        if (businessTypeIdx > -1) {
            $scope.exposureVM.classCodes.value.splice(businessTypeIdx, 1);
        } else {
            $scope.exposureVM.classCodes.value.push(cppItem);
        }
        setSegmentFlags();
    };

    ctrl.isGlClassCodeSelected = function (glClassCode) {
        return _.findIndex($scope.exposureVM.classCodes.value, function (item) {
            return item.publicID === glClassCode.publicID;
        }) > -1;
    };

    ctrl.next = function (nextFn, form) {
        // prequal question requiredness not captured in the submission model, so pass form validity for isValid check

        var isValid = form.valid;
        $scope.showSegmentValidation = true;
        if (setSegmentFlags() == false) {
            isValid = false;
        }
        submissionVM.lobData.commercialPackage.generalLiability.coverables.exposure.classCodes.value = $scope.exposureVM.classCodes.value;
        nextFn(submissionVM, {
            valid: isValid
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'submissionViewModel', 'CoveragesUtil', 'CoverageService', 'InsuranceSuiteMetadata', 'ViewModelService', 'ama.CppFlowConstants', 'QuestionSetService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/controllers/CPPPrequalQuestionsCtrl.js
// module id = 827
// module chunks = 0